module.exports = __webpack_public_path__ + "static/media/elegantwhite1.9e0dbc10.PNG";